import React from 'react';
import { callApi } from '../../../Utils/Api/Api';
import { Button } from '@progress/kendo-react-buttons';
import OpenIdLogo from '../../../assets/logo/openid-svgrepo-com.svg';

const OpenIdLoginButton = ({ setIsLoader, setAlertMessage }) => {
  const base64UrlEncode = (arrayBuffer) => {
    const bytes = new Uint8Array(arrayBuffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  };

  const generatePkce = async () => {
    const random = new Uint8Array(32);
    window.crypto.getRandomValues(random);
    const codeVerifier = base64UrlEncode(random);
    const encoder = new TextEncoder();
    const digest = await window.crypto.subtle.digest(
      'SHA-256',
      encoder.encode(codeVerifier)
    );
    const codeChallenge = base64UrlEncode(digest);
    return { codeVerifier, codeChallenge };
  };

  const handleLogin = async () => {
    setIsLoader(true);
    try {
      const { codeVerifier, codeChallenge } = await generatePkce();
      sessionStorage.setItem('OIDC_CODE_VERIFIER', codeVerifier);
      const response = await callApi(
        `/social/auth/URL?driver=openid&code_challenge=${encodeURIComponent(codeChallenge)}&code_challenge_method=S256`,
        'GET'
      );
      if (response?.isSuccess) {
        window.location.href = response.payload.scalar;
      } else {
        setAlertMessage({
          alert: true,
          message: 'Failed to get OpenID login URL. Please try again.',
        });
      }
    } catch (error) {
      console.error('Get OpenID login URL error:', error);
      setAlertMessage({
        alert: true,
        message: 'Failed to get OpenID login URL. Please try again.',
      });
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="social-login-box k-pt-2">
      <Button
        imageUrl={OpenIdLogo}
        imageAlt="OpenID icon"
        fillMode="outline"
        className="single-login-btn"
        onClick={handleLogin}
      >
        Sign in with OpenID
      </Button>
    </div>
  );
};

export default OpenIdLoginButton;
